import { EDIT_USER, EDIT_PUBLISHER, EDIT_WPARTICLES } from '../action-types';

export const editUser = (user) => ({
  type: EDIT_USER,
  user,
});

export const editPublisher = (publisher) => ({
  type: EDIT_PUBLISHER,
  publisher,
});

export const editWPArticles = (articles) => ({
  type: EDIT_WPARTICLES,
  articles,
});
